import axios from 'axios';
import apiConfig from '../api.config';

export default function appearenceRequest(id) {
  const {
    host,
    URIs: { appearence },
  } = apiConfig;

  const uri = `${host}${appearence.replace(':hotelId', id)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
